import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const ScriptInjector = () => {
  useEffect(() => {
    const injectScripts = async () => {
      try {
        const response = await axios.get(`${API}/scripts`);
        const { header_scripts, body_scripts, footer_scripts } = response.data;

        // Inject header scripts
        if (header_scripts && header_scripts.trim()) {
          const headDiv = document.createElement('div');
          headDiv.innerHTML = header_scripts;
          
          // Move all script tags and other elements to head
          Array.from(headDiv.children).forEach(child => {
            if (child.tagName === 'SCRIPT') {
              const script = document.createElement('script');
              Array.from(child.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              script.innerHTML = child.innerHTML;
              document.head.appendChild(script);
            } else {
              document.head.appendChild(child.cloneNode(true));
            }
          });
        }

        // Inject body scripts (top)
        if (body_scripts && body_scripts.trim()) {
          const bodyDiv = document.createElement('div');
          bodyDiv.innerHTML = body_scripts;
          
          // Insert at the beginning of body
          Array.from(bodyDiv.children).forEach(child => {
            if (child.tagName === 'SCRIPT') {
              const script = document.createElement('script');
              Array.from(child.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              script.innerHTML = child.innerHTML;
              document.body.insertBefore(script, document.body.firstChild);
            } else {
              document.body.insertBefore(child.cloneNode(true), document.body.firstChild);
            }
          });
        }

        // Inject footer scripts
        if (footer_scripts && footer_scripts.trim()) {
          const footerDiv = document.createElement('div');
          footerDiv.innerHTML = footer_scripts;
          
          // Append to end of body
          Array.from(footerDiv.children).forEach(child => {
            if (child.tagName === 'SCRIPT') {
              const script = document.createElement('script');
              Array.from(child.attributes).forEach(attr => {
                script.setAttribute(attr.name, attr.value);
              });
              script.innerHTML = child.innerHTML;
              document.body.appendChild(script);
            } else {
              document.body.appendChild(child.cloneNode(true));
            }
          });
        }
      } catch (error) {
        console.error('Failed to load global scripts:', error);
      }
    };

    injectScripts();
  }, []);

  return null; // This component doesn't render anything
};

export default ScriptInjector;
